<template>
  <div class="webchatForm">
    <label>
      <p>氏名</p>
      <span>{{messageContent.name || '-'}}</span>
    </label>
    <label>
      <p>メールアドレス</p>
      <span>{{messageContent.email || '-'}}</span>
    </label>
    <label>
      <p>電話番号</p>
      <span>{{messageContent.phone || '-'}}</span>
    </label>
  </div>
</template>

<script>

export default {
  name: 'messageInput',
  props: [
    'senderType', 'content'
  ],
  computed: {
    messageContent () {
      return JSON.parse(this.content)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .webchatForm {
    margin: 5px 15px 5px 15px;
    padding: 10px;
    background: #f9f9f9;
    border-radius: 5px;
    label {
      margin-top: 15px;
      display: block;
      span {
        margin-bottom: 6px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_input.vue